// Webpack Imports
import * as bootstrap from "bootstrap";
import { fade } from "./js/animations";
import {
	homeHeroSlider,
	gameSlider,
	partnerSlider,
	gameSliderSingle,
	careerSlider,
	featuredRoleSlider,
} from "./js/carousel";
import { burgerMenuClose, backToTop, articleBackButton } from "./js/utils";
import { singleModal, tableofContent, eventAssetsExpand, careersPagination, careersFilterPagination } from "./js/ui";
import { liPassInit, liPassWidget } from "./js/pass";
import { allNewsFilterPagination, latestNewsFilter, gamesFilter, facetFilterMobile } from "./js/filters";

(function () {
	"use strict";

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll(".search-form"), (el) => {
		el.addEventListener("submit", function (e) {
			var search = el.querySelector("input");
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: "focus",
		});
	});
})();

(($) => {
	$(() => {
		fade();
		liPassInit();
		liPassWidget();
		homeHeroSlider();
		gameSlider();
		partnerSlider();
		gameSliderSingle();
		careerSlider();
		featuredRoleSlider();
		burgerMenuClose();
		backToTop();
		articleBackButton();
		singleModal();
		tableofContent();
		eventAssetsExpand();
		allNewsFilterPagination();
		latestNewsFilter();
		gamesFilter();
		facetFilterMobile();
		careersFilterPagination();
	});
})(jQuery);
